import SidebarGroup from "@/components/Sidebar/SidebarGroup";
import SidebarItem from "@/components/Sidebar/SidebarItem";
import { FluentIcon } from "@fluentui/react-icons";

export interface SidebarItem {
  label: string;
  href?: string;
  Icon: FluentIcon;
  children?: {
    label: string;
    href: string;
  }[];
}

interface SidebarProps {
  items: SidebarItem[];
}

function Sidebar({ items }: SidebarProps) {
  return (
    <div className="w-[240px]">
      {items.map((item) => {
        if (item.children) {
          const { href, children, ...rest } = item;
          return (
            <SidebarGroup key={item.label} children={children} {...rest} />
          );
        }
        if (item.href) {
          const { href, ...rest } = item;
          return <SidebarItem key={item.label} href={href} {...rest} />;
        }
        return null;
      })}
    </div>
  );
}

export default Sidebar;
